import React from 'react';
import { Box } from '@rebass/grid';
import { Button, Typography } from '@material-ui/core';
import BottomSheet from '../organisim/bottom-sheet';

const DeleteConfirmSheet = ({ open, onClose, onConfirm, isDeleting }) => {
  return (
    <BottomSheet open={open} onClose={onClose} title="Delete announcement">
      <Box mb="24px">
        <Typography variant="body1">
          Are you sure you want to delete this announcement? This can't be undone.
        </Typography>
      </Box>
      <Box mb="12px">
        <Button
          variant="outlined"
          color="secondary"
          style={{ width: '100%' }}
          disabled={isDeleting}
          onClick={onConfirm}
        >
          {isDeleting ? 'Deleting...' : 'Delete'}
        </Button>
      </Box>
      <Button variant="text" color="default" style={{ width: '100%' }} onClick={onClose}>
        Cancel
      </Button>
    </BottomSheet>
  );
};

export default DeleteConfirmSheet;
